<template>
  <div class="comment-form">
    <avatar />

    <div>
      <div
        v-if="formErrors.non_field_errors !== undefined"
        class="alert alert-danger"
        role="alert"
      >
        {{ formErrors.non_field_errors[0] }}
      </div>

      <form @submit.prevent="submitForm">
        <div class="form-group">
          <textarea
            v-model="formFields.body"
            :class="parentComment.id === undefined ? 'js-comment-textarea' : 'js-reply-textarea'"
            :placeholder="
              parentComment.id === undefined ?
                'Write a comment...' :
                (
                  'Write a reply to '
                  + `${parentComment.user.first_name} ${parentComment.user.last_name}...`
                )
            "
            required
            @keydown.enter="submitForm"
            @input="togglePlusButton"
          />
          <div
            v-if="formErrors.body !== undefined"
            class="invalid-feedback"
          >
            {{ formErrors.body[0] }}
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-primary btn-sm"
          :disabled="formSubmitting"
        >
          <template v-if="formSubmitting">
            Posting Comment
            <spinner />
          </template>
          <template v-else>
            Post Comment
          </template>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';

export default {
  components: {
    Avatar,
  },
  props: {
    objectType: {
      type: String,
      required: true,
    },
    objectId: {
      type: Number,
      required: true,
    },
    parentComment: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formSubmitting: false,
      formErrors: {},
      formFields: {
        body: '',
      },
    };
  },
  methods: {
    async submitForm() {
      this.formErrors = {};
      this.formSubmitting = true;

      let url = `posts/${this.objectId}/comment/`;
      if (this.parentComment.id !== undefined) {
        url = `comments/${this.parentComment.id}/reply/`;
      }

      const responseData = await this.api({
        url,
        method: 'POST',
        json: this.formFields,
      });

      this.formSubmitting = false;

      if (responseData.status === 200) {
        this.$store.dispatch('set_show_add_button', true);
        this.$store.dispatch('update_post', { id: this.objectId });
        this.formFields = {
          body: '',
        };
      } else if (responseData.status === 400) {
        this.formErrors = responseData.body;
      } else {
        this.formErrors = {
          non_field_errors: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }
    },
    togglePlusButton() {
      if (this.formFields.body !== '') {
        this.$store.dispatch('set_show_add_button', false);
      } else {
        this.$store.dispatch('set_show_add_button', true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .comment-form {
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: auto 1fr;
    margin-top: 1rem;
  }
</style>
